import React from 'react';
import { portfolioData as d } from '../../mock';
import Masthead from '../portfolio/Masthead';
import Navigation from '../portfolio/Navigation';

const PageShell = ({ children }) => {
  return (
    <div className="min-h-screen paper-texture text-[#1a1a1a]">
      <div className="max-w-[1200px] mx-auto px-6 py-6">
        <Masthead data={d} />
        <Navigation items={d.navigation} />
        <main className="py-12">{children}</main>
      </div>
    </div>
  );
};

export default PageShell;
